"use client";

import { useLenis } from "lenis/react";
import styled from "styled-components";

type Props = {
    label?: string;
    targetId?: string;
};

export default function ButtonLandingPage({
    label = "Poproś o wycenę",
    targetId = "formularz",
}: Props) {
    const lenis = useLenis();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        const target = document.getElementById(targetId);
        if (!target) return;

        if (lenis) {
            lenis.scrollTo(target, { duration: 1.2 });
            return;
        }

        target.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <StyledButton
            href={`#${targetId}`}
            onClick={handleClick}
            onPointerUp={(event) => {
                // Na touch sticky :hover zostaje — zdejmij fokus po tapnięciu.
                if (event.pointerType === "touch") {
                    event.currentTarget.blur();
                }
            }}
            aria-label={label}
            suppressHydrationWarning
        >
            <span className="button1__icon-wrapper" aria-hidden="true">
                <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="button1__icon-svg"
                    width={10}
                    height={10}
                >
                    <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                    />
                </svg>
                <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="button1__icon-svg button1__icon-svg--copy"
                    width={10}
                    height={10}
                >
                    <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                    />
                </svg>
            </span>
            <span className="button1__label">{label}</span>
        </StyledButton>
    );
}

const StyledButton = styled.a`
    line-height: 1;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
    background-color: #803320;
    color: #fff;
    border-radius: 9999px;
    font-weight: 500;
    padding: 0.75rem 1.5rem;
    padding-left: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background-color 0.5s, color 0.5s;

    border: none;
    cursor: pointer;
    font-family: inherit;

    .button1__icon-wrapper {
        flex-shrink: 0;
        width: 23px;
        height: 23px;
        position: relative;
        color: #233329;
        background-color: #faf6f2;
        border-radius: 50%;
        display: grid;
        place-items: center;
        overflow: hidden;
    }

    .button1__icon-svg--copy {
        position: absolute;
        transform: translate(-150%, 150%);
    }

    .button1__label {
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    /* Hover / animacja ikony tylko na urządzeniach z prawdziwym pointerem */
    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: #faf6f2;
            color: #233329;
        }

        &:hover .button1__icon-wrapper {
            color: #faf6f2;
            background-color: #803320;
        }

        &:hover .button1__icon-svg:first-child {
            transition: transform 0.3s ease-in-out;
            transform: translate(150%, -150%);
        }

        &:hover .button1__icon-svg--copy {
            transition: transform 0.3s ease-in-out 0.1s;
            transform: translate(0);
        }
    }

    @media (max-width: 767px) {
        gap: 0.5rem;
        padding: 0.65rem 1.15rem;
        padding-left: 14px;
        font-size: 0.875rem;

        .button1__icon-wrapper {
            width: 20px;
            height: 20px;
        }

        .button1__icon-svg {
            width: 8px;
            height: 8px;
        }
    }
`;
